module.exports = __webpack_public_path__ + "img/20250909165852910.01eefc45.png";